(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@ecomplus/utils"), require("vue"), require("@ecomplus/passport-client"));
	else if(typeof define === 'function' && define.amd)
		define([, , ], factory);
	else if(typeof exports === 'object')
		exports["widgetUser"] = factory(require("@ecomplus/utils"), require("vue"), require("@ecomplus/passport-client"));
	else
		root["widgetUser"] = factory(root["ecomUtils"], root["Vue"], root["EcomPassport"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__6__) {
return 